<mat-toolbar class="bg-white">
	Update Channel
	<span fxFlex></span>
	<div>
		<button class="w-5 h-5 bg-portals-primary-900 flex justify-center items-center" [disableRipple]="true" mat-fab (click)="drawer.close()">
			<mat-icon>cancel</mat-icon>
		</button>
	</div>
</mat-toolbar>

<form class="q2-content --spaced-vertical-16" [formGroup]="form" (ngSubmit)="onSubmit()">
	<div class="input-card input-image-card">
		<portals-image-uploader [aspectRatio]="1" [minRanges]="{ height: 200, width: 200 }" (imageEmitter)="getImage($event)"></portals-image-uploader>
	</div>
	<mat-card class="input-card">
		<mat-card-content>
			<mat-form-field appearance="fill" class="input-card-field">
				<mat-label>Activate Channel?</mat-label>
				<mat-select formControlName="is_active">
					<mat-option [value]="true">Yes, activate this channel</mat-option>
					<mat-option [value]="false">No, do not activate channel yet</mat-option>
				</mat-select>
			</mat-form-field>
		</mat-card-content>
	</mat-card>
	<mat-card class="input-card">
		<mat-card-content>
			<mat-form-field appearance="fill" class="input-card-field">
				<mat-label>Name</mat-label>
				<input matInput formControlName="name" />
			</mat-form-field>
		</mat-card-content>
	</mat-card>
	<mat-card class="input-card">
		<mat-card-content>
			<mat-form-field appearance="fill" class="input-card-field">
				<mat-label>Description</mat-label>
				<textarea matInput formControlName="description" rows="6"></textarea>
			</mat-form-field>
		</mat-card-content>
	</mat-card>
	<mat-card class="m-3.75">
		<mat-card-content>
			<mat-form-field appearance="fill" class="input-card-field">
				<mat-label>Link</mat-label>
				<input matInput formControlName="external_url" />
			</mat-form-field>
		</mat-card-content>
	</mat-card>
	<button [disableRipple]="true" mat-flat-button color="primary" class="h-[45px] m-3.75">Update Channel</button>
</form>
